const ITEMS = [
  "Deep Cleaning Services",
  "Trustworthy · Reliable · Budget-Friendly",
  "Post-Construction Cleaning",
  "Medical Grade Sanitization",
  "for Fresh and Dust free Home",
  "Angamaly · Chalakudy · Perumbavoor",
  "Premium & Expat Care",
  "Shampoo Washing",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <section
      className="relative border-y border-[#6CBE45]/12 bg-white py-6 overflow-hidden"
      data-testid="editorial-marquee"
      aria-hidden="true"
    >
      <div className="marquee-track items-center gap-10 pr-10">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10 whitespace-nowrap">
            <span
              className={`font-display text-2xl sm:text-3xl font-extrabold tracking-tight ${
                i % 2 === 0 ? "text-[#0F1A1C]" : "text-stroke-green"
              }`}
            >
              {item}
            </span>
            <span className="text-[#D4AF37] text-xl">✦</span>
          </span>
        ))}
      </div>
    </section>
  );
}
